import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  getGeneralIssuerSettings,
  updateGeneralIssuerSettings,
} from "../api/generalIssuerSettings"

export const useGeneralIssuerSettings = () =>
  useQuery({
    queryKey: ["general-issuer-settings"],
    queryFn: getGeneralIssuerSettings,
    select: (data) => data?.data || {},
  })

export const useUpdateGeneralIssuerSettings = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateGeneralIssuerSettings,
    onError: (err) => console.error(err),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["general-issuer-settings"] })
    },
  })
}
